import store from '../store/configureStore'
import mostrarLoading from '../actions/util/mostrarLoading'
import fecharLoading from '../actions/util/fecharLoading'

export const SLOW_REQUEST_HEADER = 'X-Slow-Request'


export const SLOW_REQUEST_CONFIG = {
  headers: {
    [SLOW_REQUEST_HEADER]: true
  }
}

export const iniciarLoading = () => {
  store.dispatch(mostrarLoading())
}

export const finalizarLoading = () => {
  store.dispatch(fecharLoading())
}
